<template>
    <section class="inner-banner">
        <picture>
            <source
                media="(max-width: 799px)"
                :srcset="this.$root.host + MobileImageName"
            />

            <img
                class="w-100"
                :src="this.$root.host + ImageName"
                alt="Career Banner"
            />
        </picture>

        <div class="banner-container w-100 h-100">
            <div class="b-container h-100 position-relative">
                <h2 class="banner-title" v-text="title"></h2>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ["title", "image"],
    data() {
        return {
            ImageName: "/assets/images/" + this.image,
            MobileImageName: "/assets/images/mobile-" + this.image
        };
    }
};
</script>
